import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { awardMembershipOptions } from '@/module/Nomen/AwardMembership/model/AwardMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type AwardMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function AwardMembershipSelectControl<T extends FieldValues>(props: AwardMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(awardMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
